import { render, staticRenderFns } from "./AddIssueForm.vue?vue&type=template&id=ab7ca96e&"
import script from "./AddIssueForm.vue?vue&type=script&lang=js&"
export * from "./AddIssueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports